"use client";

import React from "react";
import "./style.css";
import { useTranslation } from "@/lib/react/i18n";
import { IoMdLock } from "react-icons/io";

type Props = {
  averageScore?: number | null;
  src: string;
  alt?: string;
  id: string;
  isLocked?: boolean;
};

const ImageShuffledCard: React.FC<{
  params: Props;
  onClick: (imageId: string) => void;
  className?: string;
}> = ({ params, onClick, className = "" }) => {
  const { src, alt, id, averageScore, isLocked } = params;
  const isVideo = src?.toLowerCase().endsWith(".mp4");
  const { t } = useTranslation();

  return (
    <div
      className={[
        className,
        "relative overflow-hidden rounded-lg",
        isLocked ? "bg-orange-500/5" : "",
      ].join(" ")}
    >
      <div
        data-testid={`image-grid-card-${id}`}
        className="cursor-pointer w-full h-full relative"
        onClick={(event) => {
          event.stopPropagation();
          onClick(id);
        }}
      >
        {isVideo ? (
          <video
            width={300}
            height={300}
            className="object-cover w-full h-full aspect-[4/3] rounded-lg"
            src={src}
            muted
            loop
            playsInline
            autoPlay
          />
        ) : (
          <img
            alt={alt ?? ""}
            className="w-full h-full object-cover rounded-lg"
            src={src}
            loading="lazy"
            decoding="async"
          />
        )}

        {isLocked && (
          <div className="absolute top-2 left-2 z-10">
            <span className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium whitespace-nowrap bg-orange-500/15 text-orange-200 border border-orange-400/20">
              <IoMdLock className="w-3 h-3" />
              {t("Locked")}
            </span>
          </div>
        )}

        {typeof averageScore === "number" && !isNaN(averageScore) && (
          <div className="text-with-outline transform rankScoreTxtBox">
            <span className="rankScoreTxt">{averageScore}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageShuffledCard;